export function buildClubUserListPaths(clubRef) {
  if (!clubRef) return [];
  const ref = encodeURIComponent(String(clubRef));
  return [`/api/${ref}/users`, `/api/admin/clubs/${ref}/users`];
}

export function buildClubUserUserPaths(clubRef, userId) {
  if (!clubRef || !userId) return [];
  const ref = encodeURIComponent(String(clubRef));
  const uid = encodeURIComponent(String(userId));
  return [`/api/${ref}/users/${uid}`, `/api/admin/clubs/${ref}/users/${uid}`];
}
